
import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
} from "@mui/material";

import FilterListIcon from "@mui/icons-material/FilterList";

const ProjectDashboardTable = ({ title, resources }) => {
  const [sortOrder, setSortOrder] = useState("asc")

  const sortedResources = [...resources].sort((a, b) => {
    if (sortOrder === "asc") {
      return (a.resource || "").localeCompare(b.resource || "");
    } else {
      return (b.resource || "").localeCompare(a.resource || "");
    }
  });

  const handlesortToggle = () => {
    setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"))
  }

  return (
    <Card
      sx={{
        borderRadius: 4,
        boxShadow: 3,
        width: "100%",
        maxHeight: "60vh",
        minHeight: "56vh",
        height:'250px'
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          gap: 2,
          pt: 2,
          pl: 2,

        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600, color: "#003366" }}>
          {title}
        </Typography>

        <Button
          variant="outlined"
          size="small"
          startIcon={<FilterListIcon />}
          onClick={handlesortToggle}
          sx={{
            borderRadius: "20px",
            textTransform: "none",
            fontSize: "12px",
            color: "#000000",
            fontWeight: "lighter",
          }}
        >
          Sort By ({sortOrder === "asc" ? "A → Z" : "Z → A"})
        </Button>
      </Box>

      <CardContent sx={{
        p: 0,
        flex: 1,
        overflowY: "auto",
        scrollbarWidth: "none", // Firefox
        "&::-webkit-scrollbar": {
          display: "none", // Chrome, Safari
        },
      }}>
        <Table>
          <TableHead>
            <TableRow >
              <TableCell sx={{ fontWeight: 600, color: "#003366", fontSize: "12px" }}>Milestone</TableCell>
              <TableCell sx={{ fontWeight: 600, color: "#003366", fontSize: "12px" }}>
                Resource Name
              </TableCell>
              <TableCell sx={{ fontWeight: 600, color: "#003366", fontSize: "12px" }}>Role</TableCell>
              <TableCell sx={{ fontWeight: 600, color: "#003366", fontSize: "12px" }}>Assigned Task</TableCell>
              <TableCell sx={{ fontWeight: 600, color: "#003366", fontSize: "12px" }}>Completed Task</TableCell>
            </TableRow>

            <TableBody >
              {sortedResources.map((res, index) => (
                <TableRow key={index}>
                  <TableCell sx={{ fontSize: "10px" }}>{res.milestone_name}</TableCell>
                  <TableCell>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 7 }}>
                      <Typography variant="body2" sx={{ fontWeight: 500, fontSize: "10px" }}>
                        {res.resource}
                      </Typography>
                    </Box>
                  </TableCell>
                  <TableCell sx={{ fontSize: "10px" }}>{res.role}</TableCell>
                  <TableCell>
                    <Typography variant="body2" sx={{ fontWeight: 500, fontSize: "10px" }}>
                      {res.total_tasks}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" sx={{ fontWeight: 500, fontSize: "10px" }}>
                      {res.completed_tasks}
                    </Typography>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </TableHead>
        </Table>
      </CardContent>
    </Card>
  );
};
export default ProjectDashboardTable;

